import { render } from "./add-service.vue?vue&type=template&id=4ee1a25e"
import script from "./add-service.vue?vue&type=script&lang=js"
export * from "./add-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__